import React, { useContext } from "react";
import credentialOne from "../../../../assets/images/kkk.png";
import credentialTwo from "../../../../assets/images/kkr.png";
import { FeatureCard } from "../../../../global/components/FeatureCard/FeatureCard";
import useSWR from "swr";
import { fetcher } from "../../../../lib/apiConstants";
import { LoginContext } from "../../../../lib/loginContext";

export const MigrateNeptuneContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR(
    "products/",
    fetcher
  );
  const { isLoggedIn } = useContext(LoginContext);
  return (
    <>
      <div className="cloud-bg flex justify-center items-center">
        <p className="bg-text text-center">Migrate the system </p>
      </div>
      {/* {isLoggedIn && (
        <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 mt-4 md:mt-8 lg:mt-16">
          <DownloadSection
            title="Cut Sheet"
            description="Learn about 2.0 Mobile Credential features"
            backgroundImage={CatalogueBackground}
            buttonText="Download Now"
            linkField="others_link"
            products={products || []}
            isLoading={productsLoading}
            filterBySlug="13-5-mhz-mifare-reader"
            showOnlyFirst={true}
          />
        </div>
      )} */}
      <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 py-4 md:py-6 lg:py-16">
        <FeatureCard
          image={credentialTwo}
          label="Upgrading to Neptune 2.0: Enhanced Security Management
"
          description="Welcome to Neptune 2.0, the next generation of Sicunet's security management platform. This major update introduces advanced Partitioning for better system organization, intelligent Threat Level management, streamlined Group Edit functions, and high-speed Bulk Loading that reduces installation time and costs. The migration from Neptune 1.0 is straightforward—simply launch the Neptune 2.0 installer, which will automatically detect your existing installation and guide you through the upgrade sequence."
          imageLeft={true}
          hideLine={true}
        />
        <FeatureCard
          image={credentialOne}
          label="⚠️ Important: System Reset During Migration
"
          description="<strong>CRITICAL NOTICE : </strong>Migrating to Neptune 2.0 will reset ALL data to factory defaults and restore the IP address to factory settings. Before proceeding, backup all system configurations, user databases, and device parameters. Document your current IP address and network settings. After the upgrade completes, access the system using the factory default IP, reconfigure your network settings, and restore your backed-up configurations using Neptune 2.0's new Bulk Loading feature."
          imageLeft={false}
          hideLine={true}
        />
      </div>
    </>
  );
};
